<template>
    <div v-show="visible">
        <el-dialog title="修改" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="350px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                    <el-form-item prop="name" label="系统名称">
                        <el-input v-model="form.name" maxlength="80" style="width:195px;"></el-input>
                    </el-form-item>

                    <el-form-item   prop="firm" label="厂家">
                       <el-select v-model="form.firm" clearable placeholder="请选择">
                            <el-option
                                v-for="item in firms"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
 
                    <el-form-item   prop="ip" label="IP地址">
                        <el-input v-model="form.ip" maxlength="100" placeholder="比如：127.0.0.1" style="width:195px;"></el-input>
                    </el-form-item> 
 
                    <el-form-item   prop="port" label="端口">
                        <el-input v-model="form.port" maxlength="5" type="number" style="width:195px;"></el-input>
                    </el-form-item> 

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible: false,
                form:{
                    id:"",
                    name:"",
                    firm:"",
                    ip:"",
                    port:""
                },
                rules: {
                    name: [
                        { required: true, message: '请输入系统名称', trigger: 'blur' }
                    ],
                    firm: [
                        { required: true, message: '请选择厂家', trigger: 'blur' }
                    ],
                    ip: [
                        { required: true, message: '请输入IP地址', trigger: 'blur' }
                    ],
                    port: [
                        { required: true, message: '请输入端口', trigger: 'blur' }
                    ]
                },
                firms:[{
                    value: 1,
                    label: '考斯'
                }, {
                    value: 2,
                    label: '点讯'
                }, {
                    value: 3,
                    label: '海康'
                }, {
                    value: 4,
                    label: '校园广播'
                }]
            }
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(data){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.id=data.id;
                this.form.name=data.name;
                this.form.firm=data.firm;
                this.form.ip=data.ip;
                this.form.port=data.port;
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        let url= this.deviceSysUpdateUrl;
                        let data = {
                            id:this.form.id,
                            name:this.form.name,
                            firm:this.form.firm,
                            ip:this.form.ip,
                            port:this.form.port
                        };
                        // console.log(JSON.stringify(data));
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/device/devicesys/Update.vue